// extracted by mini-css-extract-plugin
module.exports = {"textArea":"TextAreaField_textArea__qMRBz","textAreaReadOnly":"TextAreaField_textAreaReadOnly__iBFLT"};